var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "supsis-table" },
    [
      _c(
        "div",
        {
          ref: "scrollContainer",
          staticClass: "supsis-scroll",
          class: { "has-groups": _vm.hasGroups },
        },
        [
          _c(
            "div",
            { staticClass: "supsis-table-header" },
            [
              _vm._l(_vm.visibleColumnDefs, function (col, index) {
                return _c(
                  "div",
                  {
                    key: col.key,
                    staticClass: "supsis-col",
                    class: [
                      "supsis-col-" + col.key,
                      { "supsis-col-fixed": col.fixed },
                    ],
                    style: _vm.getColStyle(col.key),
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "supsis-header-cell",
                        class: {
                          "supsis-resizing-active":
                            _vm.resizing.active &&
                            _vm.resizing.colKey === col.key,
                          "supsis-dragging":
                            _vm.dragging.active &&
                            _vm.dragging.dragIndex === index,
                          "supsis-drag-over":
                            _vm.dragging.active &&
                            _vm.dragging.hoverIndex === index,
                          "supsis-sortable":
                            _vm.sortableColumns && col.selectable !== false,
                          "supsis-has-sort": col.sortable,
                        },
                        attrs: {
                          draggable:
                            _vm.sortableColumns && col.selectable !== false,
                        },
                        on: {
                          dragstart: function ($event) {
                            return _vm.onDragStart($event, index)
                          },
                          dragenter: function ($event) {
                            return _vm.onDragEnter($event, index)
                          },
                          dragover: function ($event) {
                            return _vm.onDragOver($event, index)
                          },
                          dragleave: function ($event) {
                            return _vm.onDragLeave($event, index)
                          },
                          drop: function ($event) {
                            return _vm.onDrop($event, index)
                          },
                          dragend: function ($event) {
                            return _vm.onDragEnd($event)
                          },
                          contextmenu: function ($event) {
                            $event.preventDefault()
                            return _vm.onHeaderContextMenu($event, col, index)
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "supsis-header-content",
                            on: {
                              click: function ($event) {
                                return _vm.onHeaderClick($event, col)
                              },
                            },
                          },
                          [
                            col.key === "__select"
                              ? [
                                  _c("input", {
                                    staticClass: "select-all-checkbox",
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: _vm.isAllSelected,
                                      indeterminate: _vm.isIndeterminate,
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.onSelectAll.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  }),
                                ]
                              : [
                                  _vm.sortableColumns &&
                                  col.selectable !== false
                                    ? _c(
                                        "i",
                                        {
                                          staticClass:
                                            "material-icons drag-handle",
                                        },
                                        [_vm._v("drag_indicator")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "supsis-header-title" },
                                    [_vm._v(_vm._s(col.title))]
                                  ),
                                  _vm._v(" "),
                                  col.sortable
                                    ? _c(
                                        "i",
                                        {
                                          staticClass:
                                            "material-icons sort-icon",
                                          class: {
                                            "sort-active":
                                              _vm.sortState.key === col.key,
                                            "sort-asc":
                                              _vm.sortState.key === col.key &&
                                              _vm.sortState.order === "asc",
                                            "sort-desc":
                                              _vm.sortState.key === col.key &&
                                              _vm.sortState.order === "desc",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.sortState.key === col.key
                                                  ? _vm.sortState.order ===
                                                    "asc"
                                                    ? "arrow_upward"
                                                    : "arrow_downward"
                                                  : "unfold_more"
                                              ) +
                                              "\n                            "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _vm.resizable && _vm.isColumnResizable(col)
                          ? _c("span", {
                              staticClass: "supsis-resizer",
                              on: {
                                mousedown: function ($event) {
                                  return _vm.startResize($event, col.key, index)
                                },
                              },
                            })
                          : _vm._e(),
                      ]
                    ),
                  ]
                )
              }),
              _vm._v(" "),
              _vm.showColumnAdd
                ? _c(
                    "div",
                    { staticClass: "supsis-column-manager-container" },
                    [
                      _c("MinimalPopoverSelect", {
                        attrs: {
                          value: _vm.visibleColumnKeys,
                          options: _vm.columnSelectOptions,
                          multiple: true,
                          enableSearch: true,
                          "show-icon": false,
                          "show-dropdown-arrow": false,
                          "button-class": "supsis-column-manager-btn",
                          "popover-class": "supsis-column-manager-popover",
                          "search-placeholder": "Kolon ara...",
                        },
                        on: { input: _vm.onColumnMultiInput },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "trigger",
                              fn: function () {
                                return [
                                  _c(
                                    "button",
                                    {
                                      directives: [
                                        {
                                          name: "tippy",
                                          rawName: "v-tippy",
                                          value: {
                                            content: "Kolonları Yönet",
                                            placement: "left",
                                          },
                                          expression:
                                            "{ content: 'Kolonları Yönet', placement: 'left' }",
                                        },
                                      ],
                                      staticClass: "supsis-column-manager-btn",
                                      attrs: { type: "button" },
                                    },
                                    [
                                      _c(
                                        "i",
                                        { staticClass: "material-icons" },
                                        [_vm._v("more_vert")]
                                      ),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          880114761
                        ),
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _vm.hasGroups
            ? _c(
                "div",
                {
                  ref: "virtualScrollBody",
                  staticClass: "supsis-table-body supsis-virtual-scroll",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "supsis-virtual-container",
                      style: {
                        height: _vm.totalHeight + "px",
                        position: "relative",
                        width: "max-content",
                        minWidth: "100%",
                      },
                    },
                    _vm._l(_vm.visibleGroupSections, function (groupSection) {
                      return _c(
                        "div",
                        {
                          key: groupSection.groupKey,
                          staticClass: "supsis-group-section",
                          style: {
                            position: "absolute",
                            top: groupSection.top + "px",
                            left: 0,
                            width: "max-content",
                            minWidth: "100%",
                            height: groupSection.height + "px",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "supsis-group-header",
                              style: {
                                position: "sticky",
                                top: 0,
                                left: 0,
                                zIndex: 8,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.toggleGroup(groupSection.groupKey)
                                },
                              },
                            },
                            [
                              _c(
                                "i",
                                { staticClass: "material-icons expand-icon" },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.expandedGroups[
                                          groupSection.groupKey
                                        ] !== false
                                          ? "expand_more"
                                          : "chevron_right"
                                      ) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "group-label-container" },
                                [
                                  _c("span", { staticClass: "group-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        groupSection.group.label ||
                                          groupSection.group.name ||
                                          groupSection.groupKey
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "group-count" }, [
                                    _vm._v(
                                      _vm._s(groupSection.group.count || 0)
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.expandedGroups[groupSection.groupKey] !== false
                            ? _c(
                                "div",
                                {
                                  staticClass: "supsis-group-items",
                                  style: {
                                    position: "relative",
                                    height: groupSection.itemsHeight + "px",
                                  },
                                },
                                _vm._l(
                                  groupSection.visibleItems,
                                  function (item) {
                                    return _c(
                                      "div",
                                      {
                                        key:
                                          "item-" +
                                          groupSection.groupKey +
                                          "-" +
                                          item.itemIndex,
                                        staticClass: "supsis-row",
                                        style: {
                                          position: "absolute",
                                          top: item.relativeTop + "px",
                                          left: 0,
                                          width: "max-content",
                                          minWidth: "100%",
                                          height: _vm.itemHeight + "px",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.onRowClick(
                                              _vm.getRowData(item),
                                              item.itemIndex,
                                              $event
                                            )
                                          },
                                          dblclick: function ($event) {
                                            _vm.onRowDblClick(
                                              _vm.getRowData(item),
                                              item.itemIndex,
                                              $event
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm.getRowData(item)
                                          ? _vm._l(
                                              _vm.visibleColumnDefs,
                                              function (col) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: col.key,
                                                    staticClass: "supsis-col",
                                                    class: [
                                                      "supsis-col-" + col.key,
                                                      {
                                                        "supsis-col-fixed":
                                                          col.fixed,
                                                      },
                                                    ],
                                                    style: _vm.getColStyle(
                                                      col.key
                                                    ),
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "supsis-cell-content",
                                                        class: {
                                                          "supsis-filterable-cell":
                                                            _vm.filterable &&
                                                            col.filterable !==
                                                              false &&
                                                            col.key !==
                                                              "__select",
                                                        },
                                                        on: {
                                                          contextmenu:
                                                            function ($event) {
                                                              $event.preventDefault()
                                                              _vm.onCellContextMenu(
                                                                $event,
                                                                _vm.getRowData(
                                                                  item
                                                                ),
                                                                col,
                                                                item.itemIndex
                                                              )
                                                            },
                                                        },
                                                      },
                                                      [
                                                        col.key === "__select"
                                                          ? [
                                                              _c("input", {
                                                                staticClass:
                                                                  "row-select-checkbox",
                                                                attrs: {
                                                                  type: "checkbox",
                                                                  disabled:
                                                                    _vm.isRowDisabled(
                                                                      _vm.getRowData(
                                                                        item
                                                                      )
                                                                    ) ||
                                                                    (_vm
                                                                      .selectedRowKeys
                                                                      .length >=
                                                                      _vm.maxSelectCount &&
                                                                      !_vm.isRowSelected(
                                                                        _vm.getRowData(
                                                                          item
                                                                        )
                                                                      )),
                                                                },
                                                                domProps: {
                                                                  checked:
                                                                    _vm.isRowSelected(
                                                                      _vm.getRowData(
                                                                        item
                                                                      )
                                                                    ),
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                      _vm.onRowSelect(
                                                                        _vm.getRowData(
                                                                          item
                                                                        ),
                                                                        $event
                                                                      )
                                                                    },
                                                                },
                                                              }),
                                                            ]
                                                          : [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "supsis-cell-wrapper",
                                                                },
                                                                [
                                                                  _vm._t(
                                                                    "cell-" +
                                                                      col.key,
                                                                    function () {
                                                                      return [
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "supsis-default-cell",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.getMaskedCellValue(
                                                                                  _vm.getRowData(
                                                                                    item
                                                                                  ),
                                                                                  col
                                                                                )
                                                                              )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    },
                                                                    {
                                                                      row: _vm.getRowData(
                                                                        item
                                                                      ),
                                                                      value:
                                                                        _vm.getMaskedCellValue(
                                                                          _vm.getRowData(
                                                                            item
                                                                          ),
                                                                          col
                                                                        ),
                                                                      column:
                                                                        col,
                                                                      rowIndex:
                                                                        item.itemIndex,
                                                                    }
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _vm.filterable &&
                                                                  col.filterable !==
                                                                    false
                                                                    ? _c(
                                                                        "i",
                                                                        {
                                                                          staticClass:
                                                                            "material-icons supsis-filter-icon",
                                                                          class:
                                                                            {
                                                                              "supsis-filter-active":
                                                                                _vm.isFilterActive(
                                                                                  _vm.getRowData(
                                                                                    item
                                                                                  ),
                                                                                  col.key
                                                                                ),
                                                                            },
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                $event.stopPropagation()
                                                                                _vm.onFilterToggle(
                                                                                  col.key,
                                                                                  _vm.getRowData(
                                                                                    item
                                                                                  )[
                                                                                    col
                                                                                      .key
                                                                                  ],
                                                                                  _vm.getRowData(
                                                                                    item
                                                                                  ),
                                                                                  item.itemIndex
                                                                                )
                                                                              },
                                                                          },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                                                    " +
                                                                              _vm._s(
                                                                                _vm.isFilterActive(
                                                                                  _vm.getRowData(
                                                                                    item
                                                                                  ),
                                                                                  col.key
                                                                                )
                                                                                  ? "remove_circle"
                                                                                  : "add_circle"
                                                                              ) +
                                                                              "\n                                                "
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                ],
                                                                2
                                                              ),
                                                            ],
                                                      ],
                                                      2
                                                    ),
                                                  ]
                                                )
                                              }
                                            )
                                          : _vm._l(
                                              _vm.visibleColumnDefs,
                                              function (col) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: col.key,
                                                    staticClass:
                                                      "supsis-col supsis-skeleton-col",
                                                    class: [
                                                      "supsis-col-" + col.key,
                                                    ],
                                                    style: _vm.getColStyle(
                                                      col.key
                                                    ),
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "supsis-cell-content",
                                                      },
                                                      [
                                                        col.key === "__select"
                                                          ? [
                                                              _c("input", {
                                                                staticClass:
                                                                  "row-select-checkbox skeleton-checkbox",
                                                                attrs: {
                                                                  type: "checkbox",
                                                                  disabled: "",
                                                                },
                                                              }),
                                                            ]
                                                          : [
                                                              _c("div", {
                                                                staticClass:
                                                                  "supsis-skeleton-line",
                                                              }),
                                                            ],
                                                      ],
                                                      2
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                      ],
                                      2
                                    )
                                  }
                                ),
                                0
                              )
                            : _vm._e(),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              )
            : _c(
                "div",
                {
                  staticClass: "supsis-table-body",
                  class: { "supsis-zebra": _vm.zebra },
                },
                [
                  _vm._l(_vm.data, function (row, rowIndex) {
                    return _c(
                      "div",
                      {
                        key: _vm.getRowKey(row, rowIndex),
                        staticClass: "supsis-row",
                        on: {
                          click: function ($event) {
                            return _vm.onRowClick(row, rowIndex, $event)
                          },
                          dblclick: function ($event) {
                            return _vm.onRowDblClick(row, rowIndex, $event)
                          },
                        },
                      },
                      _vm._l(_vm.visibleColumnDefs, function (col) {
                        return _c(
                          "div",
                          {
                            key: col.key,
                            staticClass: "supsis-col",
                            class: [
                              "supsis-col-" + col.key,
                              { "supsis-col-fixed": col.fixed },
                            ],
                            style: _vm.getColStyle(col.key),
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "supsis-cell-content",
                                class: {
                                  "supsis-filterable-cell":
                                    _vm.filterable &&
                                    col.filterable !== false &&
                                    col.key !== "__select",
                                },
                                on: {
                                  contextmenu: function ($event) {
                                    $event.preventDefault()
                                    return _vm.onCellContextMenu(
                                      $event,
                                      row,
                                      col,
                                      rowIndex
                                    )
                                  },
                                },
                              },
                              [
                                col.key === "__select"
                                  ? [
                                      _c("input", {
                                        staticClass: "row-select-checkbox",
                                        attrs: {
                                          type: "checkbox",
                                          disabled:
                                            _vm.isRowDisabled(row) ||
                                            (_vm.selectedRowKeys.length >=
                                              _vm.maxSelectCount &&
                                              !_vm.isRowSelected(row)),
                                        },
                                        domProps: {
                                          checked: _vm.isRowSelected(row),
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.onRowSelect(row, $event)
                                          },
                                        },
                                      }),
                                    ]
                                  : [
                                      _c(
                                        "div",
                                        { staticClass: "supsis-cell-wrapper" },
                                        [
                                          _vm._t(
                                            "cell-" + col.key,
                                            function () {
                                              return [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "supsis-default-cell",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getMaskedCellValue(
                                                          row,
                                                          col
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                            {
                                              row: row,
                                              value: _vm.getMaskedCellValue(
                                                row,
                                                col
                                              ),
                                              column: col,
                                              rowIndex: rowIndex,
                                            }
                                          ),
                                          _vm._v(" "),
                                          _vm.filterable &&
                                          col.filterable !== false
                                            ? _c(
                                                "i",
                                                {
                                                  staticClass:
                                                    "material-icons supsis-filter-icon",
                                                  class: {
                                                    "supsis-filter-active":
                                                      _vm.isFilterActive(
                                                        row,
                                                        col.key
                                                      ),
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                      return _vm.onFilterToggle(
                                                        col.key,
                                                        row[col.key],
                                                        row,
                                                        rowIndex
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                    " +
                                                      _vm._s(
                                                        _vm.isFilterActive(
                                                          row,
                                                          col.key
                                                        )
                                                          ? "remove_circle"
                                                          : "add_circle"
                                                      ) +
                                                      "\n                                "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        2
                                      ),
                                    ],
                              ],
                              2
                            ),
                          ]
                        )
                      }),
                      0
                    )
                  }),
                  _vm._v(" "),
                  !_vm.data || !_vm.data.length
                    ? _c(
                        "div",
                        { staticClass: "supsis-empty" },
                        [
                          _vm._t("empty", function () {
                            return [_c("span", [_vm._v("Veri bulunamadı")])]
                          }),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.loading
                    ? _c("div", { staticClass: "supsis-loading-overlay" })
                    : _vm._e(),
                ],
                2
              ),
        ]
      ),
      _vm._v(" "),
      _c("ContextMenu", {
        attrs: {
          visible: _vm.cellContextMenu.visible,
          x: _vm.cellContextMenu.x,
          y: _vm.cellContextMenu.y,
          items: _vm.cellContextMenuItems,
        },
        on: { "item-click": _vm.onCellContextMenuItemClick },
      }),
      _vm._v(" "),
      _c("ContextMenu", {
        attrs: {
          visible: _vm.headerContextMenu.visible,
          x: _vm.headerContextMenu.x,
          y: _vm.headerContextMenu.y,
          items: _vm.headerContextMenuItems,
        },
        on: { "item-click": _vm.onHeaderContextMenuItemClick },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }